// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__17U_m","title":"AfterBackImages_title__2I4pB","images":"AfterBackImages_images__3w--2"};